import React from "react";

const FireAssuranceContext = React.createContext({});

export const FireAssuranceProvider = FireAssuranceContext.Provider;
export const FireAssuranceConsumer = FireAssuranceContext.Consumer;
export default FireAssuranceContext;
